import { createSlice } from '@reduxjs/toolkit';
import { createReply, createReview, getReviewList } from './reviewThunk';
import { RootState } from '~/utils/redux/store';

export interface IReviewState {
  isRefresh: boolean;
}

export const initialState: IReviewState = {
  isRefresh: false,
};

const reviewSlice = createSlice({
  name: 'review',
  initialState,
  reducers: {},
  extraReducers(builder) {
    // GET: Get review list
    builder
      .addCase(getReviewList.pending, (_state) => {})
      .addCase(getReviewList.fulfilled, (_state) => {
        _state.isRefresh = false;
      })
      .addCase(getReviewList.rejected, (_state) => {
        _state.isRefresh = false;
      });

    // POST: Create Review
    builder
      .addCase(createReview.pending, (_state) => {})
      .addCase(createReview.fulfilled, (_state) => {})
      .addCase(createReview.rejected, (_state) => {});

    // POST: Create Reply
    builder
      .addCase(createReply.pending, (_state) => {})
      .addCase(createReply.fulfilled, (_state) => {
        _state.isRefresh = true;
      })
      .addCase(createReply.rejected, (_state) => {
        _state.isRefresh = true;
      });
  },
});

// Action
export const reviewActions = reviewSlice.actions;

// Selectors
export const selectIsRefreshReviewList = (state: RootState) => state.review.isRefresh;

// Reducer
const reviewReducer = reviewSlice.reducer;
export default reviewReducer;
